import { composeOrderType, MARKET_KIND, splitOrderType } from './constants';
import { SIMULATE_COPY } from './content';

// Enough digits for any price; drops float noise such as 0.37000000000000005.
const SIGNIFICANT_DIGITS = 12;
const RATIO_DIGITS = 3;
const { form, empty } = SIMULATE_COPY;

export const formatNumber = (n: number): string => String(parseFloat(n.toPrecision(SIGNIFICANT_DIGITS)));

/** Prices, SL and TP, where 0 means "not set". */
export const formatOptional = (n: number): string => (n ? formatNumber(n) : empty);

export const formatText = (s: string): string => s.trim() || empty;

export const formatRatio = (slave: number, master: number): string => String(parseFloat((slave / master).toPrecision(RATIO_DIGITS)));

/** Readable order type ("Sell Limit"); unknown wire values pass through untouched. */
export const formatOrderType = (orderType: string): string => {
  const { side, kind } = splitOrderType(orderType);
  if (composeOrderType(side, kind) !== orderType) return formatText(orderType);
  return kind === MARKET_KIND ? form.sides[side] : `${form.sides[side]} ${form.kinds[kind]}`;
};

/** Wire timestamps use the ISO "T" separator; a space reads better. */
export const formatExpiration = (s: string): string => formatText(s.replace('T', ' '));

export const formatTime = (seconds: number): string => new Date(seconds * 1000).toLocaleTimeString();
